<template>
  <div class="page_wrap_mobile">
    <!-- 背景图 -->
    <div class="background_image"></div>

    <!-- 产品特点标题 -->
    <h2 class="product_title">产品特点</h2>
    <!-- Tab 切换 -->

    <navi-tabs :data="tabs" @changeTab="handleTabClick" v-model="activeTab"></navi-tabs>
    <!-- <div class="tab_wrap_mobile" :class="{ 'three-tabs': tabs.length === 3 }">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane v-for="(tab, index) in tabs" :key="index" :label="tab.label" :name="tab.name"></el-tab-pane>
      </el-tabs>
    </div> -->
    <!-- 图片和说明 -->
    <div class="content_wrap_mobile">
      <img :src="currentImage.src" alt="" class="content_image" />
      <div class="content_bg">
        <p class="content_text">{{ currentImage.text }}</p>
      </div>
    </div>

    <!-- 新增内容 -->
    <div class="content_wrap_mobile content_wrap_mobile_bg">
      <h3 class="content_subtitle">无人机集控飞行系统</h3>
      <p class="content_description">“高效、稳定”的“无人化、集群化”飞行平台，又是针对各个行业用户实现“智能化”的应用系统</p>
      <!-- 将高亮内容移到底部 -->
      <h4 class="content_highlight bottom_highlight">不仅是“无人”，更多是“智能”</h4>

    </div>
  </div>
</template>

<script>
import NaviTabs from "@/components/naviTabs/index";
export default {
  components: {
    NaviTabs
  },
  data() {
    return {
      activeTab: 'tab1', // 默认选中的 Tab
      tabs: [],
      images: {},
      imgList: [],
      currentSource: '', // 用于存储当前的 source 参数
    };
  },
  created() {
    this.updateImgList();
    this.currentSource = new URLSearchParams(window.location.search).get('source') || '';
  },
  watch: {
    // 监听 URL 的变化
    '$route.fullPath': {
      immediate: true,
      handler() {
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get('source');
        if (source !== this.currentSource) {
          this.currentSource = source;
          this.updateImgList();
        }
      },
    },
  },
  computed: {
    currentImage() {
      return this.images[this.activeTab] || {};
    },
  },
  methods: {
    updateImgList() {
      const urlParams = new URLSearchParams(window.location.search);
      const source = urlParams.get('source');
      const selectedText = localStorage.getItem('selectedText') || '';
      this.activeTab = 'tab1'
      this.currentSource = source;
      switch (this.currentSource) {
        case "product_lie_11":
          this.images = {
            tab1: {
              src: "https://hr2.chnsoft.com.cn/img/全域立体覆盖.jpg",
              text: "突破空中、地面、水中、海面的场景界限，实现立体空间无死角巡视，构建全方位、多维度的巡检网络，杜绝传统单一场景巡检的盲区问题。",
            },
            tab2: {
              src: "https://hr2.chnsoft.com.cn/img/异构协同集控.jpg",
              text: "可集中调度与控制无人机、地面巡检机器人、无人作业处置车、机器狗、无人艇等多元无人装备，实现跨平台协同运作，提升装备利用效率。",
            },
            tab3: {
              src: "https://hr2.chnsoft.com.cn/img/高阶智能赋能.jpg",
              text: "融合自主路径规划、多装备协同控制技术，搭配高精度AI识别模块、多模态大模型技术，完成从路径规划、装备调度到异常捕捉、数据研判的全流程智能运作。",
            },
            tab4: {
              src: "https://hr2.chnsoft.com.cn/img/全链条自动化.jpg",
              text: "无需人工现场干预，实现巡检任务自主启动、过程自动推进、结果智能分析，大幅降低人工成本，提升巡检的及时性与可靠性。",
            },
            // tab5: {
            //   src: 'https://hr2.chnsoft.com.cn/img/%EF%BC%885%EF%BC%89%E8%88%AA%E7%BA%BF%E8%A7%84%E5%88%92.png',
            //   text: '具备在二维地图、实景三维环境中，在线为无人机、无人船、无人车规划航线。支持面、带、点灵活调整，独创多装备组合规划（如无人车+无人机空地联动），并具备智能航线安全检查功能，保障安全执行任务。',
            // },
            tab6: {
              src: "https://hr2.chnsoft.com.cn/img/精准态势感知.jpg",
              text: "通过多装备联动采集与AI智能分析，精准捕获异常目标、设备故障等关键信息，为场景运维提供精准的数据支撑与决策依据。",
            },
            tab7: {
              src: "https://hr2.chnsoft.com.cn/img/数字场景赋能.jpg",
              text: "通过三维实时建模构建场景数字孪生，实现三维模型智能化应用，为各领域提供精准、动态的数字化支撑。",
            },
            // tab8: {
            //   src: "https://hr2.chnsoft.com.cn/img/精准态势感知.jpg",
            //   text: "系统对带有地理信息的高精度三维点云和三维模型实施管理，模拟显示无人装备实时位置、动态数据、工作状态、任务进度等，结合实时回传图像，实现三维场景下的无人化装备实时管控。",
            // },
            // tab9: {
            //   src: "https://hr2.chnsoft.com.cn/img/数字场景赋能.png",
            //   text: "按照业务场景需求，针对消防火灾现场、城市管理街道、光伏场区、警务重点区域、河道湖泊等实际场景，无人机对几公里范围内的建筑、地形地貌进行倾斜摄影，图像同步到系统中，实时建立三维点云与模型。",
            // },
            // tab10: {
            //   src: 'https://hr2.chnsoft.com.cn/img/%EF%BC%8810%EF%BC%89%E8%88%AA%E5%8A%A1%E8%B0%83%E5%BA%A6.png',
            //   text: '系统提供灵活的飞行调度模式，包括：单点指点飞行（精准直达目标）、连续指点飞行（自由规划航线）、一键顺控（执行预设动作序列）及连续监控（自动巡航监控）。系统同时支持在高精度数字地图与三维点云、模型上进行选点操作，增强操控精度与灵活性。',
            // },
          };
          this.tabs = [
            { name: "tab1", label: "全域立体覆盖" },
            { name: "tab2", label: "异构协同集控" },
            { name: "tab3", label: "高阶智能赋能" },
            { name: "tab4", label: "全链条自动化" },
            // { name: 'tab5', label: '航线规划' },
            { name: "tab6", label: "精准态势感知" },
            { name: "tab7", label: "数字场景赋能" },
            // { name: 'tab8', label: '三维全息管控' },
            // { name: 'tab9', label: '三维实时建模' },
            // { name: 'tab10', label: '航务调度' },
          ];
          // 等 DOM/数据更新后再把当前图片填充进来，确保先清空
          this.$nextTick(() => {
            this.displayedImage = this.images[this.activeTab] || {};
          });
          break;
        case "product_lie_12":
          this.tabs = [
            { name: "tab1", label: "全域全场景覆盖" },
            { name: "tab2", label: "前沿技术深度融合 " },
            { name: "tab3", label: "云边端体系架构" },
            { name: "tab4", label: "无人化安全作业" },
            { name: "tab5", label: "多模态协同作业 " },
            { name: "tab6", label: "高适配性兼容拓展" },
            { name: "tab7", label: "数据价值深度挖掘" },
          ];
          this.images = {
            tab1: {
              src: "https://hr2.chnsoft.com.cn/img/全域全场景覆盖.jpg",
              text: "纵向贯通电网各电压等级、各专业领域，横向覆盖平原、山地、高原、沿海等复杂地理环境，实现无死角、全维度巡检覆盖。",
            },
            tab2: {
              src: "https://hr2.chnsoft.com.cn/img/前沿技术深度融合.jpg",
              text: "集成数字孪生、AI 视觉识别、5G 高速传输、北斗高精度定位等核心技术，打造技术引领的智能化巡检产品。",
            },
            tab3: {
              src: "https://hr2.chnsoft.com.cn/img/云边端体系架构.jpg",
              text: "打造“云、边、端”整体结构，云端融合行业多端数据，在业务上进行整体管控，边端系统向上同步数据，快速响应云端任务指令。终端搭载边缘算力，实现精准目标识别。",
            },

            tab4: {
              src: "https://hr2.chnsoft.com.cn/img/无人化安全作业.png",
              text: "依赖于无人机、无人车的智能无人化作业能力，全程无需人工高空、野外介入，规避极端环境、高危场景作业风险，大幅提升运维安全系数与人员作业舒适度。",
            },
            tab5: {
              src: "https://hr2.chnsoft.com.cn/img/多模态协同作业.jpg",
              text: "支持多无人机智能集中调度巡检、无人机与无人车协同联动、固定翼与多旋翼机型互补，适配不同场景高效作业需求。",
            },
            tab6: {
              src: "https://hr2.chnsoft.com.cn/img/高适配性兼容拓展.png",
              text: "兼容不同厂家、不同类型电网设备，支持功能模块柔性扩展与技术迭代升级，适配电网数字化转型长期需求。",
            },
            tab7: {
              src: "https://hr2.chnsoft.com.cn/img/数据价值深度挖掘.jpg",
              text: "支持构建巡检大数据中台，利用多模态大模型对数据资产化管理与多维度分析，为电网设备健康评估、运维策略优化提供数据支撑。",
            },
          };
          this.$nextTick(() => {
            this.displayedImage = this.images[this.activeTab] || {};
          });
          break;
        // 可根据需要继续添加更多case
        default:
          this.imgList = [];
      }
    },
    handleTabClick(tab) {
      this.activeTab = tab.name;
    },
  },
};
</script>

<style lang="scss" scoped>
// 页面整体样式
.page_wrap_mobile {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // padding: 16PX;
  font-family: PingFang TC;


  .background_image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    //   height: 924px;
    background: url('../../assets/home/proFeaBg.png') no-repeat center center;
    background-size: cover;
    z-index: -1;
    height: 55%;
  }

  // 产品特点标题样式
  .product_title {
    text-align: center;
    font-family: PingFang SC;
    font-size: 16PX;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0px;
    margin: 24PX 0px 20PX;
    font-variation-settings: "opsz" auto;
    color: #1E242A;
  }

  // Tab 样式
  .tab_wrap_mobile {
    margin: 10px auto;
    text-align: center;
    padding: 0px 16PX;

    .el-tabs__header {
      justify-content: center;
    }
  }

  .three-tabs {
    width: 100%;
    display: flex;
    justify-content: center;
  }


  // 去掉 el-tab-pane 的灰色边框
  .el-tabs__header {
    border-bottom: none;
  }

  .el-tabs__item {
    height: 40PX;
    line-height: 40PX;
    font-size: 14PX;
    
    padding: 0px 18px 6px;
    margin-bottom: 16PX;
  }

  // 图片和说明样式
  .content_wrap_mobile {
    text-align: center;
    width: 100%;
    height: 23.4vh;
    // margin-top: 20px;
    //   padding: 0px 18.75%;
    position: relative;
    border-radius: 4PX;
    padding: 0PX 16PX;

    .content_image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      display: block;

      /* 超出600px高度部分裁剪显示 */
      overflow: hidden;
      border-radius: 8PX;
    }

    .content_bg {
      position: absolute;
      height: 80PX;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      position: absolute;
      background: linear-gradient(1deg, rgba(30, 36, 42, 0.6) 12%, rgba(30, 36, 42, 0) 83%);
      // width: calc(100% - 18.75% - 18.75% + 2px);
      // margin-top: -165px;
      border-radius: 8PX;
      // margin-bottom: 40px;
      position: absolute;
      bottom: 0px;
      width: calc(100% - 32PX); /* 减去左右padding */
      padding: 12px 16px;
    }

    .content_text {
      /* 文字居中 */
      color: #fff;
      font-size: 8PX;
      
      width: 100%;
      text-align: center;
      line-height: 1.5;
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }

    .content_subtitle {
      font-size: 16PX;
      font-weight: bold;
      color: #1E242A;
      padding-top: 40PX;
      text-align: center;
    }

    .content_description {
      font-size: 10PX;
      color: #1E242A;
      margin: 10PX 16PX 0PX;
      line-height: 1.5;
      text-align: center;
    }

    .content_highlight {
      font-family: PingFang SC;
      font-size: 10PX;
      font-weight: bold;
      line-height: normal;
      letter-spacing: normal;
      color: #1E242A;
      text-align: center;
      // margin-top: 15px;
      // position: absolute;
      // bottom: 121px;
      // margin-left: 340px;
    }

    .content_uav_image {}
  }

  // 新增背景样式
  .content_wrap_mobile_bg {
    // padding-bottom: 40px;
    background: url('../../assets/home/uavBgMobile.png') no-repeat center center;
    height: 330PX;
    position: relative; // 新增，确保子元素绝对定位基于此
    margin-top: 40PX;
    background-size: 100% 100%;
  }

  // 新增：底部高亮样式
  .bottom_highlight {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 40PX;
    margin: 0 auto;
    text-align: center;
  }

  .ho_top {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    background: linear-gradient(180deg, rgba(28, 54, 93, 0.9) 0%, rgba(28, 54, 93, 0.3) 100%, rgba(28, 54, 93, 0) 100%);
  }

  .carousel_wrap {
    position: relative;

    .el-carousel__item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .tips_font {
      position: absolute;
      top: 304px;
      left: 0;
      z-index: 5;
      color: #fff;
      font-size: 25PX;


    }
  }

  ::v-deep .el-tabs__item {
    /* 修改为您想要的文字大小 */
    //   font-size: 20px !important;
  }

  .el-tabs__item:hover {
    /* 修改为您想要的文字大小 */
    color: #0F6BF6;
  }

  .el-tabs__item.is-active {
    font-weight: bold;
    color: #0F6BF6;
    border-bottom: 2PX solid #0F6BF6;
  }

  .el-tabs__active-bar {
    background-color: #0F6BF6 !important;
  }


  .el-tabs__nav-wrap::after {
    color: #0F6BF6;
    position: static !important;

  }
}

::v-deep .el-carousel__button {
  display: none;
}

::v-deep .el-tabs__item {
  /* 修改为您想要的文字大小 */
  font-weight: normal !important;
}
</style>